<template>
    <nav class="navbar">
        <button class="navbar-toggle" @click="toggleMenu">☰</button>
        <ul :class="['navbar-links', { active: menuOpen }]">
            <li v-for="(item, index) in menuItems" :key="index">
                <router-link class="nav-item" :to="item.route" exact @click.native="closeMenuOnMobile">
                    {{ item.label }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "NavBar",
    props: {
        user: { type: String, default: "" },
    },
    data() {
        return {
            menuOpen: false
        };
    },
    computed: {
        menuItems () {
            return [
                { label: this.$t("Home"), route: "/home" },
                { label: this.$t("Services"), route: "/services" },
                { label: this.$t("Use cases"), route: "/use-cases" },
                { label: this.$t("Applications"), route: "/applications" },
                { label: this.$t("Data space"), route: "/data-space" },
                { label: this.$t("Profile"), route: `/user/@${this.user}` },
            ];
        },
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenuOnMobile() {
            if (window.innerWidth <= 1039) {
                this.menuOpen = false;
            }
        },
    },
};
</script>

<style scoped>
.navbar {
    display: flex;
    align-items: center;
}

.navbar-links {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.navbar-toggle {
    display: none;
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
}
@media (max-width: 1280px) {
    .navbar {
        padding: 0 20px;
        position: absolute;
        right: 0;
        z-index: 4;
    }
    .navbar-toggle {
        display: block;
        color: var(--color-text);
    }

    .navbar-links {
        position: fixed;
        top: 70px;
        right: 0;
        flex-direction: column;
        width: 100%;
        padding: 1rem;
        gap: 0.75rem;
        display: none;
        z-index: 40;
        margin-top: 0;
        background-color: var(--color-surface);
        border-top: 1px solid var(--color-border);
        border-bottom: 1px solid var(--color-border);
    }

    .navbar-links.active {
        display: flex;
    }
    .nav-item {
        display: block;
    }
}
</style>
